module.exports = __webpack_public_path__ + "static/process-animation-f2ecd2bd6e947d66d7ee84489991bd56.gif";